module.exports = __webpack_public_path__ + "img/card-s05.8c0ec05b.jpg";